<template>

</template>

<script>
    export default {
        name: "Hospital"
    }
</script>

<style scoped>

</style>
